module.exports = __webpack_public_path__ + "static/media/1.21422ab5.jpg";